import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import FaviconManager from '@app/components/FaviconManager';
import store from '@app/store';
import Hotjar from '@hotjar/browser';
import { ModalProvider } from '@shared/components/Modal';

import App from './app';
import { isProductionDomain } from './shared/utils/domain';

function initHotjar() {
  if (isProductionDomain()) {
    const PRODUCTION_SITE_ID = 6365653;
    const hotjarVersion = 6;
    Hotjar.init(PRODUCTION_SITE_ID, hotjarVersion);
  }
}

initHotjar();
const appEl = document.querySelector('#app');
const root = createRoot(appEl);

root.render(
  <StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ModalProvider>
            <FaviconManager />

            <App />
          </ModalProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </StrictMode>,
);
